import { Modelo } from '@ext/index';
import * as Types from './MensajeAutomatico.types';
import * as Chats from '../';
import moment, { Moment } from 'moment';
import { Guid } from 'guid-typescript';
import { isArray } from 'util';

export class IMensajeAutomatico extends Modelo {

    public constructor( Json: any = null ) {
        super( Json );
        if ( Json )
            this.set();
    }

    public Tipo: string = '';
    public Contenido: string = '';
    public Activo: boolean = false;

    public get Nombre()
    {
        if ( this.Tipo == 'confirmacion' )
        {
            return 'Confirmación de venta';
        }
        else if ( this.Tipo == 'despacho' )
        {
            return 'Despacho de una venta';
        }
        else if ( this.Tipo == 'manuales' )
        {
            return 'Envio de manuales';
        }
    }

    public get Descripcion()
    {
        if ( this.Tipo == 'confirmacion' )
        {
            return 'Este mensaje se envia al crear una venta';
        }
        else if ( this.Tipo == 'despacho' )
        {
            return 'Se envia al despachar una venta';
        }
        else if ( this.Tipo == 'manuales' )
        {
            return 'Se envia al facturar una venta';
        }
    }

    public get Comodines()
    {
        let e: { Descripcion: string, Codigo: string}[] = []
        if ( this.Tipo == 'confirmacion' )
        {

        }
        else if ( this.Tipo == 'despacho' )
        {
            e.push( { Codigo: '@nickname', Descripcion: 'Introduce el nickname del cliente.' } )
            e.push( { Codigo: '@transporte', Descripcion: 'Introduce el transporte del envío'} )
            e.push( { Codigo: '@tracking', Descripcion: 'Introduce el codigo de tracking del envío'} )
        }

        else if ( this.Tipo == 'manuales' )
        {
            e.push( { Codigo: '@nickname', Descripcion: 'Introduce el nickname del cliente.' } )
            e.push( { Codigo: '@links', Descripcion: 'Introduce el o los links a los manuales'} )
        }

        return e;
    }

    public getJson(): any {
        let json: any = {};

        json.tipo = this.Tipo;
        json.mensaje = this.Contenido;
        json.activo = this.Activo ? 'S' : 'N';
        return json;
    }

    public set(): boolean {

        this.Tipo = this.Json.tipo;
        this.Contenido= this.Json.mensaje;
        this.Activo= this.Json.activo == 'S';

        this.Existe = true;
        return this.Existe;
    }

}
